/*
  Keeps the cart UI truthful after a back/forward navigation.

  The cart count bubble and the cart drawer are rendered into the page by Liquid
  at request time. An AJAX add-to-cart only mutates the *live* DOM, so a page
  sitting in the browser's history still holds the markup from before the add.
  Press Back and the bubble reads 0 and <cart-drawer> still carries `is-empty`,
  which looks like the cart was emptied — a refresh "fixes" it because the server
  re-renders from the real cart. The cart itself is never actually changed.

  This re-fetches just those two sections whenever a page is shown from the
  back/forward cache (or restored by a back/forward navigation) and swaps them
  in. One small request, only on back/forward — no reload, no flash.
*/
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function innerFrom(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function syncCartUI() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', SECTIONS);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (sections) {
        /* ---- header count bubble ---- */
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bubbleHTML = innerFrom(sections['cart-icon-bubble'], '.shopify-section');
          if (bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
        }

        /* ---- drawer ---- */
        var drawer = document.querySelector('cart-drawer');
        var container = document.getElementById('CartDrawer');
        if (!drawer || !container || !sections['cart-drawer']) return;

        // Leave the drawer alone while the shopper has it open — replacing the
        // markup mid-interaction would drop the focus trap onto a removed node.
        // The bubble above is already corrected either way.
        if (drawer.classList.contains('active')) return;

        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshContainer = doc.querySelector('#CartDrawer');
        var freshDrawer = doc.querySelector('cart-drawer');
        if (!freshContainer) return;

        container.innerHTML = freshContainer.innerHTML;

        // `is-empty` sits on <cart-drawer> itself, which is OUTSIDE #CartDrawer,
        // so the innerHTML swap above does not cover it. Its CSS hides the header
        // and collapses the items area, so a stale copy renders a blank drawer.
        if (freshDrawer) {
          drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }

        // #CartDrawer-Overlay lives inside #CartDrawer and was just replaced, so
        // the close handler bound in CartDrawer's constructor is gone with it.
        var overlay = container.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function () {
        /* Network or parse failure: leave the page as it is. The cart itself is
           unaffected and a refresh still shows the true contents. */
      });
  }

  window.addEventListener('pageshow', function (event) {
    // Restored from the back/forward cache (Safari does this even with no-store).
    if (event.persisted) {
      syncCartUI();
      return;
    }
    // Or reached by a Back/Forward navigation that re-used a cached response.
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') syncCartUI();
  });
})();
